import { graphql, HttpResponse } from 'msw'
import { type EnrollmentMultiVerifyEmailData, type EnrollmentMultiVerifyEmailSubmitOutput } from '../../../../models'

export const getEnrollmentMultiVerifyEmailDataMock: EnrollmentMultiVerifyEmailData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/verify-email',
  enrollmentData: {
    email: 'test@gmail.com',
    applicationId: '1234567890',
  },
}

export const submitEnrollmentMultiVerifyEmailDataMock: EnrollmentMultiVerifyEmailSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/verify-phone',
  enrollmentData: {
    email: 'test@gmail.com',
    applicationId: '1234567890',
  },
}

export const submitEnrollmentMultiResendEmailDataMock: EnrollmentMultiVerifyEmailSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/verify-email',
  enrollmentData: {
    email: 'test@gmail.com',
    applicationId: '1234567890',
  },
}

export const mockGetEnrollmentMultiVerifyEmailData = graphql.mutation('getEnrollmentMultiVerifyEmailData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiVerifyEmailDataMock } })
})

export const mockSubmitEnrollmentMultiVerifyEmailData = graphql.mutation('submitEnrollmentMultiVerifyEmailData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiVerifyEmailDataMock } })
})

export const mockSubmitEnrollmentMultiResendEmailData = graphql.mutation('submitEnrollmentMultiResendEmailData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiResendEmailDataMock } })
})

export const mockEnrollmentMultiVerifyEmail = [
  mockGetEnrollmentMultiVerifyEmailData,
  mockSubmitEnrollmentMultiVerifyEmailData,
  mockSubmitEnrollmentMultiResendEmailData,
]
